import BaseService from '@/core/source/BaseClassicService';

export default class DeptService extends BaseService {
    adaptation(data) {
        return data.map(item => ({
            id: item.dept_id,
            type_id: item.dept_type_id,
            fname: item.dept_name,
            name: item.dept_sname,
            struct_sname_inv: item.dept_struct_sname_inv

        }))
    }
}